import { memo as Memo } from 'react';
import dayjs from 'dayjs';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Components
import Text from '../Text';
import Image from '@components/global/Image';
import HTMLContainer from '@components/global/HTMLContainer';

//* Styles
import IndividualTopSectionStyle from './style';

const IndividualTopSection = Memo(({ image, title, underline, category, time, createdAt, company, innerCategory, deliverables, translate }) => {
	return (
		<IndividualTopSectionStyle className={`individual-top-section-container-wrap ${underline ? 'underline' : ''}`}>
			<Image
				priority
				src={image.url}
				alt={image.alt}
				className={'topImg'}
			/>

			<HTMLContainer>
				<div className='flexCont'>
					<Text
						tag={'h1'}
						className={`h5 font-poppins font-medium title`}>
						{title}
					</Text>

					<div className={'otherOptionWrap'}>
						<div className={'otherOptionItemCont'}>
							<div className={'otherOptionItem'}>
								<Text
									className={`p-m font-anonymous font-bold otherOptionTitle`}
									text={'category'}
								/>

								<Text className={`p-m font-poppins font-light otherOption`}>{innerCategory || category}</Text>
							</div>

							<div className={'otherOptionItem'}>
								<Text
									className={`p-m font-anonymous font-bold otherOptionTitle`}
									text={createdAt ? translate('datePublished') : translate('client')}
								/>

								{createdAt ? <Text className={`p-m font-poppins font-light otherOption`}>{dayjs(createdAt).format('DD.MM.YY')}</Text> : <Text className={`p-m font-poppins font-light otherOption`}>{company}</Text>}
							</div>

							<div className={'otherOptionItem'}>
								<Text
									className={`p-m font-anonymous font-bold otherOptionTitle`}
									text={time ? translate('readTime') : translate('deliverables')}
								/>

								{time ? (
									<Text className={`p-m font-poppins font-light otherOption`}>
										{time}
										{translate('min')}
									</Text>
								) : (
									<div className={'otherOption'}>
										{deliverables
											? deliverables.map((i, k) => {
													return (
														<p
															key={k}
															className={`p-m font-poppins font-light line-txt`}>
															{i}
														</p>
													);
											  })
											: null}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</HTMLContainer>
		</IndividualTopSectionStyle>
	);
});

export default withLanguageContext(IndividualTopSection, ['translate']);
